import { useId } from 'react';

/**
 * Ids for a labelled form control, plus the `aria-describedby` tying its description,
 * character count and error together. Prefers an explicit `id`, then `name`, then a
 * generated one; ids for elements that aren't rendered stay out of `describedBy`.
 */
export function useFieldIds({
  id,
  name,
  hasDescription,
  hasCharCount,
  hasError,
}: {
  id?: string;
  name?: string;
  hasDescription?: boolean;
  hasCharCount?: boolean;
  hasError?: boolean;
}) {
  const fallbackId = useId();
  const fieldId = id ?? name ?? fallbackId;

  const descriptionId = hasDescription ? `${fieldId}-description` : undefined;
  const charCountId = hasCharCount ? `${fieldId}-char-count` : undefined;
  const errorId = hasError ? `${fieldId}-error` : undefined;

  return {
    fieldId,
    descriptionId,
    charCountId,
    errorId,
    describedBy: [descriptionId, charCountId, errorId].filter(Boolean).join(' '),
  };
}
